import { MutableRefObject } from 'react';
import HIBPPasswordChecker from 'react-have-i-been-pwned';

export type HibpGateState = { loading: boolean; pwned: boolean };

type Props = {
  password: string;
  hibpRef: MutableRefObject<HibpGateState>;
};

export const PasswordHibpSync = ({ password, hibpRef }: Props) => (
  <HIBPPasswordChecker password={password}>
    {({ initial, loading, pwned }) => {
      hibpRef.current = initial
        ? { loading: true, pwned: false }
        : { loading, pwned };
      return null;
    }}
  </HIBPPasswordChecker>
);
